import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapImportInvoice } from "@/redux/mappers/MasterMapper/MasterMapper";
// import { mapInvoicePayload } from "../../../../redux/mappers/Import/CreateNewJob/InvoiceMain";

export const importinvoicemainApi = createApi({
  reducerPath: "importinvoicemainApi",
  baseQuery,
  tagTypes: ["ImportInvoice"],

  endpoints: (builder) => ({
    // 🔹 Get all invoices for a master ID
    getInvoiceImportByMasterId: builder.query({
      query: ({ id }) => {
        return `import/invoice/main/${id}`;
      },
      transformResponse: (response) => {

        const data = response?.data?.invoices ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item,idx) => ({
          ...item,
          id: item.importInvoiceId,
          srNo : 1 + idx,
           totalProductValue : response?.data?.totalProductValue,
          totalInvoiceValue : response?.data?.totalInvoiceValue
        }));
      },
      providesTags: ["ImportInvoice"],
    }),

     getImportInvoiceMaster: builder.query({
      query: ({ id }) => {
        return `import/invoice/main/${id}`;
      },
      transformResponse: (response) => {

        return response?.data?.invoices.map(mapImportInvoice) ?? [];     
      },
      providesTags: ["ImportInvoice"],
    }),



    // 🔹 Create a new import invoice
    createImportInvoice: builder.mutation({
      query: ({ id, ...data }) => {
        return {
          url: `import/invoice/main/${id}`,
          method: "PUT",
          body: { invoice: data },
        };
      },
      invalidatesTags: ["ImportInvoice"],
    }),

    // 🔹 Update an existing import invoice
    updateImportInvoice: builder.mutation({
      query: ({ id, subId, ...data }) => {
        return {
          url: `import/invoice/main/${id}/${subId}`,
          method: "PUT",
          body: { invoice: data },
        };
      },
      invalidatesTags: ["ImportInvoice"],
    }),

    // 🔹 Delete import invoice
    deleteImportInvoice: builder.mutation({
      query: ({ id }) => {
        return {
          url: `import/invoice/main/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ImportInvoice"],
    }),
  }),
});

export const {
  useGetInvoiceImportByMasterIdQuery,
  useLazyGetInvoiceImportByMasterIdQuery,
  useGetImportInvoiceMasterQuery,
  // useGetImportInvoiceMainQuery,
  useCreateImportInvoiceMutation,
  useUpdateImportInvoiceMutation,
  useDeleteImportInvoiceMutation,
} = importinvoicemainApi;
